import React, {useEffect} from 'react';
import './Modal.css';
import {addScrollBarPadding, removeScrollBarPadding} from '../App/App';


const Modal = ({ isOpen, onClose, children }) => {

    useEffect(() => {

        if (isOpen) {
            addScrollBarPadding();
        } else {
            removeScrollBarPadding();
        }

        return () => {
            removeScrollBarPadding();
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="modal__overlay" onClick={onClose}>
            <div className="modal__content" onClick={e => e.stopPropagation()}>
                {children}
                <button className="modal__close" onClick={onClose}>Закрыть</button>
            </div>
        </div>
    );
}

export default Modal;